module.exports = __webpack_public_path__ + "static/media/feelingbetter.67585425.svg";